import { Delete, Edit } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import moment from "moment";
import React, { Fragment, useContext } from "react";
import { TIME_ZONE } from "../../../../constants";
import { useMutation } from "react-query";
import { IsLoadingResponse } from "../../../../utils/Helper";
import DataTabel from "../../../../reuseable/DataTabel";
import { TABEL_UNIQUE_ID } from "../../../../constants/RoutingConstants/RoutingConstants";
import SweetConfirmation from "../../../../reuseable/sweetConfirmation";
import {
  Delete_Category_Attribute_Map,
  Get_Details_Category_Attribute_Map,
} from "../../../../Apis/categoryAttributeMapApi/CategoryAttributeMapApi";
import CategoryAttributeMapContext from "../../../../context/CategoryAttributeMapContext/CategoryAttributeMapContext";

const CategoryAttributeMapDataTabelContainer = (props) => {
  const {
    filter,
    setFilter,
    record,
    pageSize,
    page,
    setPageSize,
    setPage,
    setFormData,
    setdialogs,
    setId,
    setIsEdit,
    setSortBy,
    setSortOrder,
    sortOrder,
  } = useContext(CategoryAttributeMapContext);
  const { isLoading, data, handleOpenandClosePopup, refetch } = props;

  /**
   * get category attribute map Details
   */
  const {
    mutate: categoryAttributeMapDetails,
    isLoading: isLoadingCategoryAttributeMapDetails,
  } = useMutation((categoryAttributeMapId) =>
    Get_Details_Category_Attribute_Map(
      categoryAttributeMapId,
      setFormData,
      setdialogs
    )
  );

  const GetCategoryAttributeMapDetails = (categoryAttributeMapId) => {
    categoryAttributeMapDetails(categoryAttributeMapId);
    setId(categoryAttributeMapId);
    setIsEdit(false);
  };

  /**
   * delete category attribute map
   */
  const { mutate: categoryAttributeMapDelete, isLoading: isLoadingDelete } =
    useMutation((categoryAttributeMapId) =>
      Delete_Category_Attribute_Map(categoryAttributeMapId, refetch)
    );

  const DeleteCategoryAttributeMap = async (categoryAttributeMapId) => {
    let { isConfirmed } = await SweetConfirmation();
    if (isConfirmed) {
      categoryAttributeMapDelete(categoryAttributeMapId);
    }
  };

  /**
   *
   * @param {Sorting obj} col
   * Table Sorting
   */

  const sorting = (col) => {
    if (sortOrder === "") {
      let found = col.find((obj) => {
        return obj.field;
      });
      setSortBy(found.field);
      setSortOrder("ASC");
    }
    if (sortOrder === "ASC") {
      let found = col.find((obj) => {
        return obj.field;
      });
      setSortBy(found.field);
      setSortOrder("DSC");
    }
    if (sortOrder === "DSC") {
      setSortBy();
      setSortOrder("");
    }
  };

  const defaultColumns = [
    {
      flex: 0.1,
      minWidth: 250,
      field: "name",
      headerName: "Attribute Master Name",
      renderCell: (params) =>
        params.row.attributeMaster?.name
          ? params.row.attributeMaster?.name
          : "--",
    },
    {
      flex: 0.1,
      minWidth: 180,
      field: "attributeType",
      headerName: "Attribute Type",
      renderCell: (params) =>
        params.row.attributeMaster?.attributeType
          ? params.row.attributeMaster?.attributeType === 1
            ? "Box"
            : params.row.attributeMaster?.attributeType === 2
            ? "Drop Down"
            : params.row.attributeMaster?.attributeType === 3
            ? "Image"
            : "--"
          : "--",
    },
    {
      flex: 0.1,
      minWidth: 180,
      field: "createdAt",
      headerName: "CreatedAt",
      sortable: false,
      renderCell: (params) =>
        moment(params.row.createdAt)
          .utcOffset(TIME_ZONE)
          .format("DD MMM, YYYY hh:mm"),
    },
    {
      flex: 0.1,
      minWidth: 100,
      field: "actions",
      headerName: "Actions",
      sortable: false,

      renderCell: (params) => (
        <>
          <div style={{ paddingRight: "5px" }}>
            <Tooltip title="Edit">
              <IconButton
                aria-label="edit"
                onClick={() =>
                  GetCategoryAttributeMapDetails(
                    params.row.categoryAttributeMapId
                  )
                }
              >
                <Edit style={{ color: "#7366ff" }} />
              </IconButton>
            </Tooltip>
          </div>
          <div style={{ paddingRight: "5px" }}>
            <Tooltip title="Delete">
              <IconButton
                aria-label="delete"
                onClick={() =>
                  DeleteCategoryAttributeMap(params.row.categoryAttributeMapId)
                }
              >
                <Delete style={{ color: "red" }} />
              </IconButton>
            </Tooltip>
          </div>
        </>
      ),
    },
  ];

  return (
    <Fragment>
      <IsLoadingResponse
        isLoading={isLoadingCategoryAttributeMapDetails || isLoadingDelete}
      />
      <DataTabel
        filter={filter}
        setFilter={setFilter}
        handleOpenandClosePopup={handleOpenandClosePopup}
        data={data}
        defaultColumns={defaultColumns}
        record={record}
        pageSize={pageSize}
        page={page}
        setPageSize={setPageSize}
        setPage={setPage}
        sorting={sorting}
        isLoading={isLoading}
        sortOrder={sortOrder}
        setSortBy={setSortBy}
        setSortOrder={setSortOrder}
        id={TABEL_UNIQUE_ID.categoryAttributeMapId}
        addButton={true}
      />
    </Fragment>
  );
};

export default CategoryAttributeMapDataTabelContainer;
